import { WidgetFeature } from 'enums/WidgetFeature';

import { useFeatureToggle } from './useFeatureToggle';
import { useIsAuthUsed } from './useIsAuthUsed';

export const useInAuthZone = () => {
    const limitUnauthorizedFeatures = useFeatureToggle(WidgetFeature.LimitUnauthorizedFeatures);

    const authUsed = useIsAuthUsed();

    return authUsed || limitUnauthorizedFeatures === false;
};
